module.exports = __webpack_public_path__ + "img/hand.ca594f63.png";